import { Trans } from "react-i18next";
import { t } from "i18next";
import { useState, KeyboardEvent, useContext, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserAstronaut } from "@fortawesome/pro-solid-svg-icons";
import { ChatbotStateContext } from "../utils/chatbotContext";
import { useWebSocketContext } from "../utils/chatbotWSContext";
import { ChatConversation, ChatConversationHistoryArray } from "../models/chatbotModels";


export const ChatbotConversationNavigator = () => {
  const chatbotCurrentState = useContext(ChatbotStateContext);
  const { getConversationMssgs } = useWebSocketContext();

  const [history, setHistory] = useState<ChatConversationHistoryArray>([]);
  const [hoveredConversation, setHoveredConversation] = useState<string>();

  useEffect(() => {
    const currentConvHistory = chatbotCurrentState?.conversationHistory ? chatbotCurrentState.conversationHistory : [];
    setHistory(currentConvHistory);
    // When history changes, fetch latest message for selected conversation
    if (chatbotCurrentState.selectedConversationId !== "") {
      getConversationMssgs(chatbotCurrentState.selectedConversationId);
    }

  }, [chatbotCurrentState.conversationHistory, chatbotCurrentState.selectedConversationId, getConversationMssgs]);

  const handleSelect = (conversation: ChatConversation) => {
    getConversationMssgs(conversation.conversation_id);
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>, conversation: ChatConversation) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleSelect(conversation);
    }
  };

  const handleHover = (conversation: ChatConversation) => {
    setHoveredConversation(conversation.conversation_id || "");
  };

  return (
    <>
      <div className="flex items-center">
        <FontAwesomeIcon icon={faUserAstronaut} className="p-4" />
        <span className="font-unleashed text-xl">Wingman History</span>
      </div>
      {history.length > 0 ? (
        history.map((conversation) => (
          <div
            role="button"
            tabIndex={0}
            title={t`Select Wingman Conversation`}
            key={conversation.message_id}
            className={`flex justify-between items-center px-4 py-2 mb-2 ${chatbotCurrentState.selectedConversationId === conversation.conversation_id
              ? "bg-unleashed-pink text-white"
              : "bg-white hover:bg-unleashed-pink hover:text-white"
            }`}

            onClick={() => handleSelect(conversation)}
            onMouseEnter={() => handleHover(conversation)}
            onMouseLeave={() => setHoveredConversation("")}
            onKeyDown={(event) => handleKeyDown(event, conversation)}
          >
            <div
              className={`truncate font-semibold ${chatbotCurrentState.selectedConversationId === conversation.conversation_id || hoveredConversation === conversation.conversation_id
                ? "text-white"
                : "text-gray-500"
              }`}
            >
              {conversation.message_text}
            </div>
          </div>
        ))
      ) : (
        <p className="px-4 py-2 text-ua-pink"><Trans>No conversations to display</Trans></p>
      )}
    </>
  );
};
